import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { TokenSessionService } from '@shared/services/token.session.service';
export enum SocketTopics {
  Events = 'update-events',
  Alarms = 'update-alarms',
  Config = 'update-config',
  AvgDatas = 'update-avg_datas',
  InstDatas = 'update-inst_datas',

}
export enum EventRealTimeType {
  ALARMS = 'alarms',
  EVENTS = 'events',
  CONFIG = 'config',
  AVG_DATAS = 'avg_datas',
  INST_DATAS = 'inst_datas',
}
@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socket: Socket;

  constructor(private tokenSessionService: TokenSessionService) {
    this.socket = io(`${document.location.protocol}//${document.location.hostname}${environment.apiPort}`, {
      transports: ['websocket'],
      withCredentials: true,
      query: {
        userId: this.tokenSessionService.userInfo._id
      },
    });
  }


   emit(event: SocketTopics|string, data: any): void {
    this.socket.emit(event, data);
  }

   on(event: SocketTopics|string): Observable<any> {
    return new Observable((observer) => {
      this.socket.on(event, (data) => {
        observer.next(data);
      });

      return () => {
        this.socket.off(event);
      };
    });
  }

  subscribeToBackend(equipmentId: string, type: EventRealTimeType): void{
    this.emit('subscribe', {userId: this.tokenSessionService.userInfo?._id, equipmentId, type});
  }

  unsubscribeToBackend(equipmentId: string, type: EventRealTimeType): void{
    this.emit('unsubscribe', {userId: this.tokenSessionService.userInfo?._id, equipmentId, type});
  }
}
